'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _canclePolicyChange = require('./cancle-policy-change.png');

var _canclePolicyChange2 = _interopRequireDefault(_canclePolicyChange);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  CancellationPolicy: {
    displayName: 'CancellationPolicy'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/CancellationPolicy/CancellationPolicy.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var CancellationPolicy = _wrapComponent('CancellationPolicy')((_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(CancellationPolicy, _React$Component);

  function CancellationPolicy() {
    (0, _classCallCheck3.default)(this, CancellationPolicy);
    return (0, _possibleConstructorReturn3.default)(this, (CancellationPolicy.__proto__ || (0, _getPrototypeOf2.default)(CancellationPolicy)).apply(this, arguments));
  }

  (0, _createClass3.default)(CancellationPolicy, [{
    key: 'render',
    value: function render() {
      return _react3.default.createElement(
        'div',
        { style: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' } },
        _react3.default.createElement(
          'h3',
          null,
          'Change and Cancellation Policy'
        ),
        _react3.default.createElement(
          'div',
          { style: { paddingTop: 40, paddingBottom: 40 } },
          _react3.default.createElement('img', { src: _canclePolicyChange2.default, alt: 'Cancellation Policy Logo' })
        ),
        _react3.default.createElement(
          'div',
          { style: { marginBottom: 16 } },
          'Please be informed that our cancellation policy is updated!',
          ' ',
          _react3.default.createElement(
            'a',
            {
              href: _config2.default.baseURL.en + '/help-center/local-expert?topic=Change%20and%20Cancellation%20policy&source=cancellation-modal',
              target: '_blank' },
            'Read here.'
          )
        ),
        _react3.default.createElement(
          'button',
          {
            style: {
              userSelect: 'none',
              padding: '7px 12px',
              borderRadius: '5px',
              border: '1px solid transparent',
              display: 'inline-block',
              boxSizing: 'border-box',
              textDecoration: 'none',
              textAlign: 'center',
              cursor: 'pointer',
              fontWeight: 500,
              outline: 'none',
              color: '#ffffff',
              background: '#e86b24'
            },
            onClick: this.props.setCancellationPolicy
          },
          'I\u2019ve Read and Accepted the New Policy.'
        )
      );
    }
  }]);
  return CancellationPolicy;
}(_react3.default.Component), _class.propTypes = {
  setCancellationPolicy: _react2.PropTypes.func
}, _temp));

exports.default = CancellationPolicy;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CancellationPolicy/CancellationPolicy.js
// module id = 1510
// module chunks = 47